/* Reusable "Prime de transport + Avantages" section for staff/teacher
 * forms (iter73). Adds/removes benefit lines and edits transport allowance.
 * Pure controlled component. */
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { Plus, Trash } from '@phosphor-icons/react';

export default function StaffBenefitsSection({ form, setForm, kind = 'staff' }) {
  const testidPrefix = kind === 'teacher' ? 'teacher' : 'staff';
  const benefits = form.other_benefits || [];

  const addBenefit = () => {
    setForm({ ...form, other_benefits: [...benefits, { label: '', amount: '' }] });
  };
  const removeBenefit = (idx) => {
    setForm({
      ...form,
      other_benefits: benefits.filter((_, i) => i !== idx),
    });
  };
  const updateBenefit = (idx, field, value) => {
    setForm({
      ...form,
      other_benefits: benefits.map((b, i) => (i === idx ? { ...b, [field]: value } : b)),
    });
  };

  return (
    <div
      className="p-3 rounded-lg border border-[#E2E8F0] bg-amber-50/40 space-y-3"
      data-testid={`${testidPrefix}-benefits-section`}
    >
      <p className="text-xs font-semibold text-amber-800">
        💰 Prime de transport & Avantages
      </p>

      <div className="space-y-1">
        <Label className="font-manrope text-xs">Prime de transport (FCFA)</Label>
        <Input
          type="number" min="0" step="1"
          value={form.transport_allowance}
          onChange={(e) => setForm({ ...form, transport_allowance: e.target.value })}
          placeholder="ex: 25 000"
          className="border-[#E2E8F0]"
          data-testid={`${testidPrefix}-transport-allowance`}
        />
      </div>

      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label className="font-manrope text-xs">Autres avantages</Label>
          <Button
            type="button" size="sm" variant="outline"
            onClick={addBenefit}
            className="h-7 text-xs border-amber-300 text-amber-700"
            data-testid={`${testidPrefix}-add-benefit-btn`}
          >
            <Plus size={12} className="mr-1" /> Ajouter
          </Button>
        </div>

        {benefits.length === 0 ? (
          <p className="text-[11px] text-[#94A3B8] italic">
            Aucun avantage additionnel. Cliquez sur « Ajouter » pour en créer un.
          </p>
        ) : (
          <div className="space-y-2">
            {benefits.map((b, i) => (
              <div key={i} className="flex gap-2 items-center"
                data-testid={`${testidPrefix}-benefit-row-${i}`}>
                <Input
                  value={b.label || ''}
                  onChange={(e) => updateBenefit(i, 'label', e.target.value)}
                  placeholder="Ex: Prime de logement, 13ème mois…"
                  className="flex-1 border-[#E2E8F0] text-xs"
                  data-testid={`${testidPrefix}-benefit-label-${i}`}
                />
                <Input
                  type="number" min="0" step="1"
                  value={b.amount ?? ''}
                  onChange={(e) => updateBenefit(i, 'amount', e.target.value)}
                  placeholder="Montant"
                  className="w-32 border-[#E2E8F0] text-xs"
                  data-testid={`${testidPrefix}-benefit-amount-${i}`}
                />
                <Button
                  type="button" size="sm" variant="ghost"
                  onClick={() => removeBenefit(i)}
                  className="h-8 w-8 p-0 text-red-600 hover:bg-red-50"
                  data-testid={`${testidPrefix}-benefit-remove-${i}`}
                >
                  <Trash size={14} />
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
